import styled, { css } from 'styled-components';
import { DESKTOP_WIDTH, HEADER_HEIGHT } from 'Styles/variables/sizes';

const activeStyles = css`
  span {
    color: ${({ theme: { colors } }) => colors.green_600};
  }
  svg {
    path,
    circle,
    rect {
      stroke: ${({ theme: { colors } }) => colors.green_600};
    }
  }
`;
const afterStyles = css`
  content: '';
  height: 3px;
  background-color: ${({ theme: { colors } }) => colors.green_600};
  position: absolute;
  top: -12px;
  margin: 0 ${({ theme: { sizing } }) => sizing.fds_size_16};
  left: 0;
  right: 0;
`;

const navItemStyles = css`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 ${({ theme: { sizing } }) => sizing.fds_size_16};
  cursor: pointer;
  &:hover {
    ${activeStyles}
  }
  > svg {
    margin-right: 6px;
  }
  ${({ isActive }) =>
    isActive &&
    css`
      ${activeStyles}
      &:after {
        ${afterStyles}
      }
    `};
  @media (max-width: ${DESKTOP_WIDTH}) {
    border-left: none;
    &::after {
      content: none;
    }
  }
`;

export const NavItem = styled.li`
  ${navItemStyles}
`;
export const Links = styled.ul`
  display: flex;
  align-items: center;
  @media (max-width: ${DESKTOP_WIDTH}) {
    display: none;
    &.is-open {
      position: absolute;
      display: flex;
      width: 100%;
      flex-direction: column;
      left: 0;
      top: ${HEADER_HEIGHT};
      z-index: 3;
      height: 100%;
      background: ${({ theme: { colors } }) => colors.green_200};
      padding: 30px;
      > li {
        padding: 1rem;
        border-top: 1px solid rgb(61 58 98 / 10%);
        width: 100%;
        &:last-child {
          border-bottom: 1px solid rgb(61 58 98 / 10%);
        }
      }
    }
  }
`;

export const HelpNavItem = styled.li`
  ${navItemStyles}
  padding-right: ${({ theme: { sizing } }) => sizing.fds_size_08};
  padding-left: 0;
  svg {
    margin-right: 0;
    path {
      stroke: initial;
    }
  }
  span {
    display: none;
  }
  &::before {
    content: '';
    width: 1px;
    height: ${({ theme: { sizing } }) => sizing.fds_size_32};
    margin: 0 ${({ theme: { sizing } }) => sizing.fds_size_16};
    background-color: ${({ theme: { colors } }) => colors.moon_500};
  }
  @media (max-width: ${DESKTOP_WIDTH}) {
    svg {
      margin-right: 6px;
    }
    span {
      display: block;
    }
    &::before {
      content: none;
    }
  }
`;

export const AccountNavItem = styled.li`
  ${navItemStyles}
  padding-right: 0;
  padding-left: ${({ theme: { sizing } }) => sizing.fds_size_08};
  svg {
    margin-right: 0;
    rect {
      stroke: initial;
    }
  }
  &:hover {
    svg {
      rect {
        stroke: initial;
      }
    }
  }
  span {
    display: none;
  }
  &::after {
    content: none;
  }

  @media (max-width: ${DESKTOP_WIDTH}) {
    svg {
      margin-right: 6px;
    }
    svg rect {
      fill: transparent;
    }
    span {
      display: block;
    }
  }
`;
